import { Component, OnInit } from '@angular/core';
import { PasswordChangeForm } from './password-change.form';
import { AbstractFormComponent } from '../../../shared/crud/component/form.component';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import PasswordValidator from 'password-validator';

@Component({
  selector: 'password-change',
  templateUrl: './password-change.component.html',
  styleUrls: [ './password-change.component.scss' ]
})
export class PasswordChangeComponent extends AbstractFormComponent implements OnInit {

  passwordValidator: PasswordValidator;

  constructor(form: PasswordChangeForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute) {
    super(form, httpClient, toastrService, router, route);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.formMode = 'update';
    this.passwordValidator = new PasswordValidator().is().min(8)
      .has().uppercase()
      .has().lowercase()
      .has().digits()
      .has().not().spaces()
      .has().symbols();
  }

  getUrl(): string {
    return '/password/change';
  }

  submit() {
    if (this.form.controls.password.value !== this.form.controls.passwordConfirm.value) {
      this.toastrService.error('Confirm password');
      return;
    }
    this.form.controls.hash.patchValue(this.route.snapshot.queryParams.hash);
    super.submit();
  }

  onSubmit(): void {
    this.toastrService.success('Your password has been changed. You can now login to the app using the new password');
    this.router.navigate([ '/login' ]);
  }
}
